import { observable, action } from 'mobx'
import api from '../api'

class ChangeEmailStore {
  @observable confirmationId = undefined
  @observable errors = undefined

  @action.bound confirm(id) {
    if(this.confirmationId) {
      return
    }
    this.confirmationId = id

    return api.User.confirmChangeEmail(this.confirmationId)
    .catch(action((err) => {
      this.errors = err
    }))
  }
}

export default new ChangeEmailStore()



// WEBPACK FOOTER //
// ./src/stores/changeEmailStore.js